import type { StorageUploadProgress } from "@/lib/storageUpload";
import { cn } from "@/lib/utils";
import { StorageUploadProgressBar } from "./StorageUploadProgressBar";

interface UploadProgressOverlayProps {
  upload: StorageUploadProgress;
  className?: string;
  compact?: boolean;
}

export function UploadProgressOverlay({
  upload,
  className,
  compact = false,
}: UploadProgressOverlayProps) {
  return (
    <div
      className={cn(
        "absolute inset-0 z-20 flex flex-col items-center justify-center bg-black/50 px-2",
        className,
      )}
    >
      <div className={cn("w-full", compact ? "max-w-[4.5rem]" : "max-w-[8rem]")}>
        <StorageUploadProgressBar
          upload={upload}
          size="sm"
          trackClassName="bg-black/40"
          fillClassName="bg-primary-400"
          labelClassName={cn("text-white", compact ? "text-[10px]" : "text-xs")}
        />
      </div>
    </div>
  );
}
